import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const data = [
  { name: "Open", value: 120 },
  { name: "In Progress", value: 75 },
  { name: "Resolved", value: 2300 },
];

const COLORS = ["#6226EF", "#E41B1B", "#1970E6" ];

const MessagesStages = () => {
  return (
      <ResponsiveContainer width="100%" height={320}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={120}
            innerRadius={40}
            fill="#8884d8"
            label={({ name }) => `${name}`} // only show value on the slice
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip
            formatter={(value) => `${value}`}
            labelFormatter={(label) => `${label}`}
          />
          {/* Removed the <Legend /> */}
        </PieChart>
      </ResponsiveContainer>
  );
};

export default MessagesStages;
